import React from "react";
import AnimatedPageContainer from "../../assets/containers/AnimatedPageContainer";
import Classes from "./Styles/Style.module.css";
import TopBanner from "./TopBanner";
import ButtonsContainer from "./ButtonsContainer";
import BottomBanners, { ArchiveBanner } from "./BottomBanners";
import useMediaQuery from "@mui/material/useMediaQuery";
import DesktopLanding from "./DesktopLanding";

const HomePage = () => {
  const isDesktop = useMediaQuery("(min-width: 992px)");

  if (isDesktop) return <DesktopLanding />;

  const heroSection = (
    <section className={Classes.heroSection}>
      <TopBanner />
    </section>
  );
  const actionsSection = (
    <section className={Classes.actionsSection}>
      <ButtonsContainer />
    </section>
  );
  const fixedBannersSection = (
    <section className={Classes.fixedBannersSection}>
      <div className={Classes.fixedBannersList}>
        <ArchiveBanner />
      </div>
    </section>
  );
  const bannersSection = (
    <section className={Classes.bannersSection}>
      <BottomBanners includeArchive={false} />
    </section>
  );

  return (
    <AnimatedPageContainer>
      <div className={`container mb-4 ${Classes.homeContainer}`}>
        <div className={Classes.mainContent}>
          {heroSection}
          {actionsSection}
          {bannersSection}
          {fixedBannersSection}
        </div>
      </div>
    </AnimatedPageContainer>
  );
};

export default HomePage;
